import { Attributes, AttributeValues, TypeAttribute } from '@trace/types';

import { ATTRIBUTE_FILTER_ORDER, ATTRIBUTE_NAME_MAP } from '../constants/Attributes';

export type AttributesInput = {
  key: TypeAttribute;
  values: AttributeValues;
}[];

const getSelectableAttributes = (attributesInput: AttributesInput): Attributes =>
  attributesInput
    .sort((a, b) => ATTRIBUTE_FILTER_ORDER.indexOf(a.key) - ATTRIBUTE_FILTER_ORDER.indexOf(b.key))
    .reduce<Attributes>((accAttributes, attribute) => {
      if (ATTRIBUTE_NAME_MAP[attribute.key] && attribute.values) {
        return {
          ...accAttributes,
          [attribute.key]: attribute.values.sort((a, b) => a.localeCompare(b)),
        };
      }

      return accAttributes;
    }, {});

export default getSelectableAttributes;
